import { Github } from 'lucide-react';

export default function Login() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900 px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center mx-auto mb-4">
            <span className="text-white font-bold text-2xl">SH</span>
          </div>
          <h1 className="text-3xl font-bold text-white">SiteHub</h1>
          <p className="text-gray-400 mt-2">Multi-site marketing platform</p>
        </div>

        <div className="bg-gray-800 rounded-xl p-8 shadow-xl">
          <h2 className="text-xl font-semibold text-white mb-6 text-center">
            Sign in to continue
          </h2>

          <a
            href="/auth/github"
            className="flex items-center justify-center gap-3 w-full py-3 px-4 bg-gray-700 hover:bg-gray-600 text-white rounded-lg font-medium transition-colors"
          >
            <Github className="w-5 h-5" />
            Continue with GitHub
          </a>

          <p className="text-gray-500 text-sm text-center mt-6">
            Only authorized GitHub users can access this platform.
          </p>
        </div>

        <p className="text-gray-600 text-xs text-center mt-8">
          SiteHub Platform v1.0.0
        </p>
      </div>
    </div>
  );
}
